import { render } from "./ConnectionConsentDialog.vue?vue&type=template&id=2bfdefef&scoped=true"
import script from "./ConnectionConsentDialog.vue?vue&type=script&lang=js"
export * from "./ConnectionConsentDialog.vue?vue&type=script&lang=js"

import "./ConnectionConsentDialog.vue?vue&type=style&index=0&id=2bfdefef&lang=scss&scoped=true"
import "./ConnectionConsentDialog.vue?vue&type=style&index=1&id=2bfdefef&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfdefef"]])

export default __exports__